import { render, staticRenderFns } from "./IndividualUniversityPurchase.vue?vue&type=template&id=db94c95a"
import script from "./IndividualUniversityPurchase.vue?vue&type=script&lang=js"
export * from "./IndividualUniversityPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports